import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  compact?: boolean;
}

export default function MovieCard({ movie, compact = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} + 李采潭电影`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-primary-950/85 to-transparent"></div>
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-full bg-primary-950/70 backdrop-blur text-accent-300 text-[11px] font-medium">
          {movie.genres[0]}
        </span>
        <span className="absolute top-2.5 right-2.5 flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500 text-primary-950 text-[11px] font-bold">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <p className="text-background-50 font-heading font-semibold text-sm truncate">{movie.title}</p>
        </div>
      </div>
      {!compact && (
        <div className="p-3">
          <div className="flex items-center justify-between text-xs text-foreground-500 mb-2">
            <span>{movie.year} · {movie.country}</span>
            <span className="flex items-center gap-1">
              <i className="ri-fire-line text-accent-500"></i>
              {movie.popularity}
            </span>
          </div>
          <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{movie.synopsis}</p>
          <div className="flex flex-wrap gap-1.5 mt-2.5">
            {movie.genres.slice(0, 3).map((g) => (
              <span key={g} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]">
                {g}
              </span>
            ))}
          </div>
        </div>
      )}
    </Link>
  );
}